import * as React from 'react';
import type { SVGProps } from 'react';

const SvgArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" viewBox="0 0 12 21" {...props}>
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={2}
      d="m10.358 19.03-8.835-8.895 8.985-9.037"
    />
  </svg>
);

export default SvgArrow;
